import types from 'redux/types';

const toggleProcess = (data) => {
  return {
    ...data,
    type: types.TOGGLE_BACKGROUND_PROCESS,
  };
};

export default {
  toggleProcess,
};
